
import yall from 'yall-js';

document.addEventListener('DOMContentLoaded', function() {
  yall({
    observeChanges: true
  });
});
